module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_2_bafb5ea948d9f2d9756d61207b808d62.png";